"use client";
import type { Resolver } from "react-hook-form";
import React from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { usersService } from "../../../../shared/services";
import { CaUserAcademy } from "../../../../types/dto/program";
import { message } from "antd";

export interface UseUpdateStudentProps {
  student: CaUserAcademy;
  onSuccess?: (student: CaUserAcademy) => void;
}

export default function useUpdateStudents({ onSuccess, student }: UseUpdateStudentProps) {
  const [loading, setLoading] = React.useState(false);

  const schema = yup.object({

  });

  const {
    control,
    handleSubmit: onSubmit,
    reset,
  } = useForm<CaUserAcademy>({
    resolver: yupResolver(schema) as unknown as Resolver<CaUserAcademy>,
  });

  const handleSubmit = onSubmit(async (data) => {
    if (loading) return;

    setLoading(true);

    try {
      const response = await usersService.patch(student.id, {
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        phone: data.phone,
        student_code: data.student_code || null,
      });

      onSuccess?.(response);
    } catch (err: unknown) {
      const errorMessage =
        err instanceof Error ? err.message : "Error al actualizar el estudiante";
      message.error(errorMessage);
      console.error("Error updating student:", err);
    } finally {
      setLoading(false);
    }
  });

  React.useEffect(() => {
    if (student) {
      reset({
        first_name: student.first_name,
        last_name: student.last_name,
        email: student.email,
        phone: student.phone,
        student_code: student.student_code || "",
        student_teacher: student.student_teacher,
      });
    }
  }, [student, reset]);

  return {
    control,
    loading,
    handleSubmit,
  };
}
